import { useTranslation } from "react-i18next";
import { cn } from "../lib/utils";

const MAP = {
  confirmed: "bg-primary text-primary-foreground",
  checked_in: "bg-[hsl(var(--success))] text-white",
  approved: "bg-[hsl(var(--success))] text-white",
  waitlisted: "bg-accent text-accent-foreground",
  pending: "bg-[hsl(var(--warning))] text-white",
  cancelled: "bg-muted text-muted-foreground",
  no_show: "bg-destructive text-destructive-foreground",
  rejected: "bg-destructive text-destructive-foreground",
  draft: "bg-muted text-muted-foreground",
  published: "bg-primary text-primary-foreground",
};

export const StatusBadge = ({ status, className, testId }) => {
  const { t } = useTranslation();
  if (!status) return null;
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={cn(
        "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide",
        MAP[status] || "bg-muted text-muted-foreground",
        className
      )}
    >
      {t(`status.${status}`, status)}
    </span>
  );
};
